module.exports = __webpack_public_path__ + "images/device_plus_premium.655bbf1a445a163f08ff111f145da754.png";